/* eslint-disable */
/* tslint:disable */

/** acceptNetworkApplicationInvitation
 * method: put
 * summary: Accept network application invitation
 */

import type {
  GeneralOkNotOkResultDto,
  BadRequestResponseDto,
  ApiResponseDto,
} from './../api-types'

export const getPath = (idApplication: string): string =>
  `/bff-worker/network/applications/${idApplication}/accept-invitation`
export const getFullPath = (idApplication: string): string =>
  `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/network/applications/${idApplication}/accept-invitation`

export type AcceptNetworkApplicationInvitationSuccess = GeneralOkNotOkResultDto
export type AcceptNetworkApplicationInvitationError =
  | BadRequestResponseDto
  | ApiResponseDto
